export const LANGUAGE_KEYS = {
    LOGIN: {
        FTI_WELCOME_SCREEN_LOADING: 'FTI_WELCOME_SCREEN_LOADING',
        SCREEN_LOGIN_PRIVACY_POLICY_HINT: 'SCREEN_LOGIN_PRIVACY_POLICY_HINT',
        SCREEN_LOGIN_PRIVACY_POLICY_LINK: 'SCREEN_LOGIN_PRIVACY_POLICY_LINK',
        SCREEN_LOGIN_USERNAME_FIELD: 'SCREEN_LOGIN_USERNAME_FIELD',
        SCREEN_LOGIN_PASSWORD_FIELD: 'SCREEN_LOGIN_PASSWORD_FIELD',
        SCREEN_LOGIN_FORGOT: 'SCREEN_LOGIN_FORGOT',
        SCREEN_LOGIN_PASSWORD: 'SCREEN_LOGIN_PASSWORD',
        SCREEN_LOGIN_BUTTON: 'SCREEN_LOGIN_BUTTON',
        SCREEN_USERNAMELFIELD_EMPTY: 'SCREEN_USERNAMELFIELD_EMPTY',
        SCREEN_PASSWORDFIELD_EMPTY: 'SCREEN_PASSWORDFIELD_EMPTY',
        SCREEN_LOGIN_ALERT_LOGIN_FAILED: 'SCREEN_LOGIN_ALERT_LOGIN_FAILED',
        SCREEN_LOGIN_PRIVACY_POLICY_HINT_TEXT:
            'SCREEN_LOGIN_PRIVACY_POLICY_HINT_TEXT',
        SCREEN_LOGIN_PRIVACY_POLICY_LINK_BUTTON:
            'SCREEN_LOGIN_PRIVACY_POLICY_LINK_BUTTON',
        SCREEN_LOGIN_PRIVACY_POLICY_LINK_TEXT:
            'SCREEN_LOGIN_PRIVACY_POLICY_LINK_TEXT',
        SCREEN_LOGIN_ALERT_GENERIC: 'SCREEN_LOGIN_ALERT_GENERIC',
        SCREEN_PASSWORDFIELD_USERNAMEFIELD_INCORRECT:
            'SCREEN_PASSWORDFIELD_USERNAMEFIELD_INCORRECT',
        SCREEN__LOGIN_ALERT_ACCOUNT_CANCELED:
            'SCREEN__LOGIN_ALERT_ACCOUNT_CANCELED',
        SCREEN__LOGIN_ALERT_ACCOUNT_DEVICE_LIMIT:
            'SCREEN__LOGIN_ALERT_ACCOUNT_DEVICE_LIMIT',
        SCREEN__LOGIN_ALERT_ACCOUNT_SUSPENDED:
            'SCREEN__LOGIN_ALERT_ACCOUNT_SUSPENDED',
        SCREEN__LOGIN_ALERT_DEVICE_DELETED:
            'SCREEN__LOGIN_ALERT_DEVICE_DELETED',
        SCREEN__LOGIN_ALERT_DEVICE_DISABLED:
            'SCREEN__LOGIN_ALERT_DEVICE_DISABLED',
        SCREEN__LOGIN_ALERT_DIFFERENT_ACCOUNT:
            'SCREEN__LOGIN_ALERT_DIFFERENT_ACCOUNT',
        LOGIN_SCAN_QR_CODE_BUTTON: 'LOGIN_SCAN_QR_CODE_BUTTON',
        LOGIN_QR_CODE_CAMERA_NOT_ALLOWED_TITLE:
            'LOGIN_QR_CODE_CAMERA_NOT_ALLOWED_TITLE',
        LOGIN_QR_CODE_CAMERA_NOT_ALLOWED_DESCRIPTION:
            'LOGIN_QR_CODE_CAMERA_NOT_ALLOWED_DESCRIPTION',
        BUTTON_GO_TO_SETTINGS: 'BUTTON_GO_TO_SETTINGS',
        LOGIN_QR_CODE_CAMERA_VIEW_TITLE: 'LOGIN_QR_CODE_CAMERA_VIEW_TITLE',
        ERROR_UNSUCCESSFUL_QR_CODE_LOGIN_TITLE:
            'ERROR_UNSUCCESSFUL_QR_CODE_LOGIN_TITLE',
        ERROR_UNSUCCESSFUL_QR_CODE_LOGIN_DESCRIPTION:
            'ERROR_UNSUCCESSFUL_QR_CODE_LOGIN_DESCRIPTION',
        ERROR_WRONG_QR_CODE_LOGIN_TITLE: 'ERROR_WRONG_QR_CODE_LOGIN_TITLE',
        ERROR_WRONG_QR_CODE_LOGIN_DESCRIPTION:
            'ERROR_WRONG_QR_CODE_LOGIN_DESCRIPTION',
    },
    ERROR_CODE: 'ERROR_CODE',
    BUTTON_YES: 'BUTTON_YES',
    BUTTON_NO: 'BUTTON_NO',
    BACK_BUTTON: 'BACK_BUTTON',
    ADD_CHANNELS: {
        SCREEN_ADD_CHANNELS_TITLE: 'SCREEN_ADD_CHANNELS_TITLE',
    },
    MY_ACCOUNT: {
        SCREEN_MY_ACCOUNT_SWITCH_PROFILE: 'SCREEN_MY_ACCOUNT_SWITCH_PROFILE',
        SCREEN_MY_ACCOUNT_ACCOUNT_SETTINGS_OPTION:
            'SCREEN_MY_ACCOUNT_ACCOUNT_SETTINGS_OPTION',
        SCREEN_MY_ACCOUNT_APP_SETTINGS_OPTION:
            'SCREEN_MY_ACCOUNT_APP_SETTINGS_OPTION',
        SCREEN_MY_ACCOUNT_MY_RECORDINGS_OPTION:
            'SCREEN_MY_ACCOUNT_MY_RECORDINGS_OPTION',
        SCREEN_MY_ACCOUNT_NOTIFICATIONS_OPTION:
            'SCREEN_MY_ACCOUNT_NOTIFICATIONS_OPTION',
        SCREEN_MY_ACCOUNT_MEDIAPAY_OPTION: 'SCREEN_MY_ACCOUNT_MEDIAPAY_OPTION',
        SCREEN_MY_ACCOUNT_LOGOUT_OPTION: 'SCREEN_MY_ACCOUNT_LOGOUT_OPTION',
        SUSPENSION_VOLUNTARY_NOTIFICATION_TITLE:
            'SUSPENSION_VOLUNTARY_NOTIFICATION_TITLE',
        SUSPENSION_VOLUNTARY_NOTIFICATION_BODY:
            'SUSPENSION_VOLUNTARY_NOTIFICATION_BODY',
        SUSPENSION_COLLECTION_NOTIFICATION_TITLE:
            'SUSPENSION_COLLECTION_NOTIFICATION_TITLE',
        SUSPENSION_COLLECTION_NOTIFICATION_BODY:
            'SUSPENSION_COLLECTION_NOTIFICATION_BODY',
        SUSPENSION_COLLECTION_OVER_NOTIFICATION_TITLE:
            'SUSPENSION_COLLECTION_OVER_NOTIFICATION_TITLE',
        SUSPENSION_COLLECTION_OVER_NOTIFICATION_DESCRIPTION:
            'SUSPENSION_COLLECTION_OVER_NOTIFICATION_DESCRIPTION',
    },
    EPG: {
        EPG_FILTER_TITLE: 'EPG_FILTER_TITLE',
        FILTER_CATEGORIES: {
            EPG_FILTER_ORIGINAL: 'EPG_FILTER_ORIGINAL',
            EPG_FILTER_A_TO_Z: 'EPG_FILTER_A_TO_Z',
            EPG_FILTER_HD: 'EPG_FILTER_HD',
            EPG_FILTER_COMEDY: 'EPG_FILTER_COMEDY',
            EPG_FILTER_FILM: 'EPG_FILTER_FILM',
            EPG_FILTER_MUST_CARRY: 'EPG_FILTER_MUST_CARRY',
            EPG_FILTER_NEWS: 'EPG_FILTER_NEWS',
            EPG_FILTER_KIDS: 'EPG_FILTER_KIDS',
            EPG_FILTER_SPORT: 'EPG_FILTER_SPORT',
            EPG_FILTER_DOCUMENTARY_HISTORY: 'EPG_FILTER_DOCUMENTARY_HISTORY',
            EPG_FILTER_LIFESTYLE: 'EPG_FILTER_LIFESTYLE',
            EPG_FILTER_INTERNATIONAL: 'EPG_FILTER_INTERNATIONAL',
            EPG_FILTER_MUSIC: 'EPG_FILTER_MUSIC',
            EPG_FILTER_SUBSCRIBED: 'EPG_FILTER_SUBSCRIBED',
        },

        SCREEN_EPG_SELECT_CHANNELS_BUTTON: 'SCREEN_EPG_SELECT_CHANNELS_BUTTON',
        DAY_TO_TRANSLATION: [
            'DAY_NAME_SUNDAY',
            'DAY_NAME_MONDAY',
            'DAY_NAME_TUESDAY',
            'DAY_NAME_WEDNESDAY',
            'DAY_NAME_THURSDAY',
            'DAY_NAME_FRIDAY',
            'DAY_NAME_SATURDAY',
        ],
        MONTH_TO_TRANSLATION: [
            'MONTH_NAME_JANUARY',
            'MONTH_NAME_FEBRUARY',
            'MONTH_NAME_MARCH',
            'MONTH_NAME_APRIL',
            'MONTH_NAME_MAY',
            'MONTH_NAME_JUNE',
            'MONTH_NAME_JULY',
            'MONTH_NAME_AUGUST',
            'MONTH_NAME_SEPTEMBER',
            'MONTH_NAME_OCTOBER',
            'MONTH_NAME_NOVEMBER',
            'MONTH_NAME_DECEMBER',
        ],
        EPG_LOADING: 'EPG_LOADING',
        EPG_NO_INFO: 'EPG_NO_INFO',
        SCREEN_PLAYER_LIVE: 'SCREEN_PLAYER_LIVE',
        EPG_PROGRAM_TITLE_SHORT: 'EPG_PROGRAM_TITLE_SHORT',
        SCREEN_EPG_PAST_PROGRAM_ALERT_SUBTITLE:
            'SCREEN_EPG_PAST_PROGRAM_ALERT_SUBTITLE',
        SCREEN_EPG_PAST_PROGRAM_ALERT_WATCH_LIVE_BUTTON:
            'SCREEN_EPG_PAST_PROGRAM_ALERT_WATCH_LIVE_BUTTON',
        SCREEN_EPG_PAST_PROGRAM_ALERT_CANCEL_BUTTON:
            'SCREEN_EPG_PAST_PROGRAM_ALERT_CANCEL_BUTTON',
        SCREEN_EPG_FUTURE_PROGRAM_ALERT_SUBTITLE:
            'SCREEN_EPG_FUTURE_PROGRAM_ALERT_SUBTITLE',
        SCREEN_EPG_FUTURE_PROGRAM_ALERT_WATCH_LIVE_BUTTON:
            'SCREEN_EPG_FUTURE_PROGRAM_ALERT_WATCH_LIVE_BUTTON',
        SCREEN_EPG_FUTURE_PROGRAM_ALERT_CANCEL_BUTTON:
            'SCREEN_EPG_FUTURE_PROGRAM_ALERT_CANCEL_BUTTON',
        UPGRADE: {
            SCREEN_UPGRADE_PLAN_TITLE: 'SCREEN_UPGRADE_PLAN_TITLE',
            SCREEN_UPGRADE_PLAN_BODY: 'SCREEN_UPGRADE_PLAN_BODY',
            SCREEN_UPGRADE_PLAN_SUCCESS_BODY:
                'SCREEN_UPGRADE_PLAN_SUCCESS_BODY',
            SCREEN_UPGRADE_PLAN_TRANSACTION_FAILED_BODY:
                'SCREEN_UPGRADE_PLAN_TRANSACTION_FAILED_BODY',
            SCREEN_UPGRADE_PLAN_PC_BODY_FIRST:
                'SCREEN_UPGRADE_PLAN_PC_BODY_FIRST',
            SCREEN_UPGRADE_PLAN_PC_BODY_SECOND:
                'SCREEN_UPGRADE_PLAN_PC_BODY_SECOND',
            CONFIRM_BUTTON: 'CONFIRM_BUTTON',
            START_WATCHING_BUTTON: 'START_WATCHING_BUTTON',
            CONTINUE_BUTTON: 'CONTINUE_BUTTON',
            REFRESH_BUTTON: 'REFRESH_BUTTON',
        },
        CHANNEL_COMING_SOON: {
            SCREEN_CHANNEL_COMING_SOON_TEXT: 'SCREEN_CHANNEL_COMING_SOON_TEXT',
            SCREEN_LOGIN_NO_ACCOUNT: 'SCREEN_LOGIN_NO_ACCOUNT',
            SCREEN_CHANNEL_LOGIN_SIGN_UP: 'SCREEN_CHANNEL_LOGIN_SIGN_UP',
        },
        CREDIT_CARD_DETAILS: {
            SCREEN_UPGRADE_PAYMENT_TITLE: 'SCREEN_UPGRADE_PAYMENT_TITLE',
            SCREEN_UPGRADE_PAYMENT_FIRST_NAME_FIELD:
                'SCREEN_UPGRADE_PAYMENT_FIRST_NAME_FIELD',
            SCREEN_UPGRADE_PAYMENT_LAST_NAME_FIELD:
                'SCREEN_UPGRADE_PAYMENT_LAST_NAME_FIELD',
            SCREEN_UPGRADE_PAYMENT_CARD_NUMBER_FIELD:
                'SCREEN_UPGRADE_PAYMENT_CARD_NUMBER_FIELD',
            SCREEN_UPGRADE_PAYMENT_CVC_CVV_FIELD:
                'SCREEN_UPGRADE_PAYMENT_CVC_CVV_FIELD',
            SCREEN_UPGRADE_PAYMENT_MM_YYYY_FIELD:
                'SCREEN_UPGRADE_PAYMENT_MM_YYYY_FIELD',
            SCREEN_UPGRADE_PAYMENT_MM_YYYY_FIELD_SEPARATOR:
                'SCREEN_UPGRADE_PAYMENT_MM_YYYY_FIELD_SEPARATOR',
            SCREEN_UPGRADE_PAYMENT_POSTAL_CODE_FIELD:
                'SCREEN_UPGRADE_PAYMENT_POSTAL_CODE_FIELD',
            CONFIRM_BUTTON: 'CONFIRM_BUTTON',

            SCREEN_UPGRADE_PAYMENT_COULD_NOT_PROCESSED_ERROR:
                'SCREEN_UPGRADE_PAYMENT_COULD_NOT_PROCESSED_ERROR',
            FIRST_NAME_FIELD_ERROR: 'FIRST_NAME_FIELD_ERROR',
            LAST_NAME_FIELD_ERROR: 'LAST_NAME_FIELD_ERROR',
            CARD_NUMBER_FIELD_ERROR: 'CARD_NUMBER_FIELD_ERROR',
            CVC_CVV_FIELD_ERROR: 'CVC_CVV_FIELD_ERROR',
            MM_YYYY_FIELD_ERROR: 'MM_YYYY_FIELD_ERROR',
            POSTAL_CODE_FIELD_ERROR: 'POSTAL_CODE_FIELD_ERROR',
        },
        NEW_EPG_LAYOUT_NO_PROGRAM: 'NEW_EPG_LAYOUT_NO_PROGRAM',
        ACCESSIBILITY_EPG_SWITCHER_OLD_LAYOUT:
            'ACCESSIBILITY_EPG_SWITCHER_OLD_LAYOUT',
        ACCESSIBILITY_EPG_SWITCHER_NEW_LAYOUT:
            'ACCESSIBILITY_EPG_SWITCHER_NEW_LAYOUT',
        ACCESSIBILITY_EPG_CHANNEL_CARD: 'ACCESSIBILITY_EPG_CHANNEL_CARD',
    },
    SELECT_PACKAGE: {
        SCREEN_EPG_PACKAGE_FILTER_TITLE: 'SCREEN_EPG_PACKAGE_FILTER_TITLE',
    },
    DATEPICKER: {
        TITLE: 'EPG_DATE_PICKER_DIALOG_TITLE',
    },
    DRAWER: {
        SEARCH: 'SCREEN_SEARCH_PLACEHOLDER',
    },
    PROGRAM_PICKER: {
        SCREEN_PROGRAM_PICKER_MORE_DETAILS_OPTION:
            'SCREEN_PROGRAM_PICKER_MORE_DETAILS_OPTION',
        SCREEN_PROGRAM_PICKER_STARTOVER_OPTION:
            'SCREEN_PROGRAM_PICKER_STARTOVER_OPTION',
        SCREEN_PROGRAM_PICKER_RECORD_PROGRAM_OPTION:
            'SCREEN_PROGRAM_PICKER_RECORD_PROGRAM_OPTION',
        SCREEN_PROGRAM_PICKER_CANCEL_SCHEDULE_OPTION:
            'SCREEN_PROGRAM_PICKER_CANCEL_SCHEDULE_OPTION',
        SCREEN_PROGRAM_PICKER_DELETE_RECORDING_BUTTON:
            'SCREEN_PROGRAM_PICKER_DELETE_RECORDING_BUTTON',
        SCREEN_PROGRAM_PICKER_ADD_CHANNEL_TO_FAVORITES_OPTION:
            'SCREEN_PROGRAM_PICKER_ADD_CHANNEL_TO_FAVORITES_OPTION',
        SCREEN_PROGRAM_PICKER_REMOVE_CHANNEL_FROM_FAVORITES_OPTION:
            'SCREEN_PROGRAM_PICKER_REMOVE_CHANNEL_FROM_FAVORITES_OPTION',
        CANCEL_SCHEDULE_CONFIRMATION_ALERT_TITLE:
            'CANCEL_SCHEDULE_CONFIRMATION_ALERT_TITLE',
        CANCEL_SCHEDULE_CONFIRMATION_ALERT_BODY:
            'CANCEL_SCHEDULE_CONFIRMATION_ALERT_BODY',
    },
    NOTIFICATIONS: {
        RECORDING_NOTIFICATION_SCHEDULED: 'RECORDING_NOTIFICATION_SCHEDULED',
        RECORDING_NOTIFICATION_CANCELED: 'RECORDING_NOTIFICATION_CANCELED',
        NOTIFICATION_RELOAD_APP_AFTER_AGE_CHANGE_TITLE:
            'NOTIFICATION_RELOAD_APP_AFTER_AGE_CHANGE_TITLE',
        NOTIFICATION_RELOAD_APP_AFTER_AGE_CHANGE_DESCRIPTION:
            'NOTIFICATION_RELOAD_APP_AFTER_AGE_CHANGE_DESCRIPTION',
    },
    MY_RECORDINGS: {
        SCREEN_RECORDINGS_TITLE: 'SCREEN_RECORDINGS_TITLE',
        SCREEN_RECORDINGS_TAB_RECORDED: 'SCREEN_RECORDINGS_TAB_RECORDED',
        SCREEN_RECORDINGS_TAB_SCHEDULED: 'SCREEN_RECORDINGS_TAB_SCHEDULED',
        SCREEN_RECORDINGS_STORAGE_INDICATOR:
            'SCREEN_RECORDINGS_STORAGE_INDICATOR',
        SCREEN_RECORDINGS_FALLBACK_MESSAGE_NO_RECORDED:
            'SCREEN_RECORDINGS_FALLBACK_MESSAGE_NO_RECORDED',
        SCREEN_RECORDINGS_FALLBACK_MESSAGE_NO_SCHEDULED:
            'SCREEN_RECORDINGS_FALLBACK_MESSAGE_NO_SCHEDULED',
    },
    PROGRAM_DETAILS: {
        SCREEN_DETAIL_AVAILABLE_UNTIL: 'SCREEN_DETAIL_AVAILABLE_UNTIL',
        SCREEN_DETAIL_MORE_INFO_BUTTON: 'SCREEN_DETAIL_MORE_INFO_BUTTON',
        SCREEN_DETAIL_WATCH_BUTTON: 'SCREEN_DETAIL_WATCH_BUTTON',
        SCREEN_DETAIL_DURATION_MIN: 'SCREEN_DETAIL_DURATION_MIN',
        PROGRAM_DETAIL_STRIPE_PERSON: 'PROGRAM_DETAIL_STRIPE_PERSON',
    },
    DETAILS_DROPDOWN: {
        BUTTON_RENT: 'BUTTON_RENT',
        BUTTON_SUBSCRIBE: 'BUTTON_SUBSCRIBE',
        BUTTON_RENT_SUBSCRIBE: 'BUTTON_RENT_SUBSCRIBE',
        SCREEN_DETAIL_MANAGE_RECORDING_BUTTON:
            'SCREEN_DETAIL_MANAGE_RECORDING_BUTTON',
    },
    STRIPE: {
        STRIPE_VIEW_ALL_CARD: 'STRIPE_VIEW_ALL_CARD',
    },
    NO_NETWORK_CONNECTION: {
        SCREEN_ALERT_NO_NETWORK_CONNECTION_TITLE:
            'SCREEN_ALERT_NO_NETWORK_CONNECTION_TITLE',
        SCREEN_ALERT_NO_NETWORK_CONNECTION_DESCRIPTION:
            'SCREEN_ALERT_NO_NETWORK_CONNECTION_DESCRIPTION',
        TRY_AGAIN_BUTTON: 'TRY_AGAIN_BUTTON',
    },
    CONNECTION_INDICATOR: {
        NOTIFICATION_RN_INTERNET_CONNECTION_USE_MOBILE_DATA_TITLE:
            'NOTIFICATION_RN_INTERNET_CONNECTION_USE_MOBILE_DATA_TITLE',
        NOTIFICATION_RN_INTERNET_CONNECTION_USE_MOBILE_DATA_DESCRIPTION:
            'NOTIFICATION_RN_INTERNET_CONNECTION_USE_MOBILE_DATA_DESCRIPTION',
        BUTTON_IGNORE: 'BUTTON_IGNORE',
        BUTTON_GO_TO_SETTINGS: 'BUTTON_GO_TO_SETTINGS',
    },
    logout: {
        SCREEN_ALERT_LOGOUT_HEADER: 'SCREEN_ALERT_LOGOUT_HEADER',
        SCREEN_ALERT_LOGOUT_SUBHEADER: 'SCREEN_ALERT_LOGOUT_SUBHEADER',
        SCREEN_ALERT_CANCEL_BUTTON: 'SCREEN_ALERT_CANCEL_BUTTON',
        SCREEN_ALERT_LOGOUT_BUTTON: 'SCREEN_ALERT_LOGOUT_BUTTON',
    },
    TIMESHIFT_START_NOTIFICATION_TITLE: 'TIMESHIFT_START_NOTIFICATION_TITLE',
    TIMESHIFT_START_NOTIFICATION_BODY: 'TIMESHIFT_START_NOTIFICATION_BODY',
    UNSUBSCRIBED_PLAYER_INFO_TEXT: 'UNSUBSCRIBED_PLAYER_INFO_TEXT',
    UNSUBSCRIBED_PLAYER_INFO_BODY: 'UNSUBSCRIBED_PLAYER_INFO_BODY',
    UNSUBSCRIBED_PLAYER_INFO_TITLE: 'UNSUBSCRIBED_PLAYER_INFO_TITLE',
    SETTINGS_PARENTAL_CONTROL: 'SETTINGS_PARENTAL_CONTROL',
    SETTINGS_CHANGE_PIN_CODE: 'SETTINGS_CHANGE_PIN_CODE',
    SETTINGS_FORGOT_PIN_CODE: 'SETTINGS_FORGOT_PIN_CODE',
    SCREEN_AUDIO_SUBTITLES_AUDIO_LANGUAGE:
        'SCREEN_AUDIO_SUBTITLES_AUDIO_LANGUAGE',
    SCREEN_AUDIO_SUBTITLES_SUBTITLES: 'SCREEN_AUDIO_SUBTITLES_SUBTITLES',
    SCREEN_SUBTITLE_OFF: 'SCREEN_SUBTITLE_OFF',
    SUBTITLE_OTT_HEARING_IMPAIRED_TRUE: 'SUBTITLE_OTT_HEARING_IMPAIRED_TRUE',
    SETTINGS_HUNGARIAN: 'SETTINGS_HUNGARIAN',
    SETTINGS_ENGLISH: 'SETTINGS_ENGLISH',
    SETTINGS_FORGOT_PIN_TEXT_1: 'SETTINGS_FORGOT_PIN_TEXT_1',
    SETTINGS_FORGOT_PIN_TEXT_2: 'SETTINGS_FORGOT_PIN_TEXT_2',
    SETTINGS_FORGOT_PIN_TEXT_3: 'SETTINGS_FORGOT_PIN_TEXT_3',
    SETTINGS_FORGOT_PIN_TEXT_4: 'SETTINGS_FORGOT_PIN_TEXT_4',
    SCREEN_FORGOT_PIN_WEBSITE_BUTTON: 'SCREEN_FORGOT_PIN_WEBSITE_BUTTON',
    SCREEN_FORGOT_PIN_CLOSE_BUTTON: 'SCREEN_FORGOT_PIN_CLOSE_BUTTON',
    SYSTEM_PIN_ENTRY_SCREEN_TITLE: 'SYSTEM_PIN_ENTRY_SCREEN_TITLE',
    SYSTEM_PIN_ENTRY_SCREEN_BODY: 'SYSTEM_PIN_ENTRY_SCREEN_BODY',
    SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_TITLE:
        'SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_TITLE',
    SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_BODY:
        'SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_BODY',
    SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_TITLE:
        'SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_TITLE',
    SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_BODY:
        'SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_BODY',
    CHANGE_SYSTEM_PIN_SCREEN_TITLE: 'CHANGE_SYSTEM_PIN_SCREEN_TITLE',
    CHANGE_SYSTEM_PIN_SCREEN_BODY: 'CHANGE_SYSTEM_PIN_SCREEN_BODY',
    CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_TITLE:
        'CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_TITLE',
    CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_BODY:
        'CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_BODY',
    CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_TITLE:
        'CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_TITLE',
    CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_BODY:
        'CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_BODY',
    CANCEL_BUTTON: 'CANCEL_BUTTON',
    SCREEN_SEARCH_NORESULTS: 'SCREEN_SEARCH_NORESULTS',
    SCREEN_SEARCH_NORESULTS_BODY: 'SCREEN_SEARCH_NORESULTS_BODY',
    SCREEN_SEARCH: 'SCREEN_SEARCH',
    SUCCESSFUL_PIN_CHANGE: 'SUCCESSFUL_PIN_CHANGE',
    UNSUCCESSFUL_PIN_CHANGE_TITLE: 'UNSUCCESSFUL_PIN_CHANGE_TITLE',
    UNSUCCESSFUL_PIN_CHANGE_DESCRIPTION: 'UNSUCCESSFUL_PIN_CHANGE_DESCRIPTION',
    OK_BUTTON: 'OK_BUTTON',
    FTI_PARENTAL_CONTROL_CREATE_PIN_TITLE:
        'FTI_PARENTAL_CONTROL_CREATE_PIN_TITLE',
    FTI_PARENTAL_CONTROL_CREATE_PIN_DESCRIPTION:
        'FTI_PARENTAL_CONTROL_CREATE_PIN_DESCRIPTION',
    FTI_CONTINUE_BUTTON: 'FTI_CONTINUE_BUTTON',
    FTI_SUCCESSFUL_PIN_TITLE: 'FTI_SUCCESSFUL_PIN_TITLE',
    FTI_SUCCESSFUL_PIN_DESCRIPTION: 'FTI_SUCCESSFUL_PIN_DESCRIPTION',
    FTI_UNSUCCESSFUL_PIN_TITLE: 'FTI_UNSUCCESSFUL_PIN_TITLE',
    FTI_UNSUCCESSFUL_PIN_DESCRIPTION: 'FTI_UNSUCCESSFUL_PIN_DESCRIPTION',
    WATCH_AGAIN_BUTTON: 'WATCH_AGAIN_BUTTON',
    NEXT_BUTTON: 'NEXT_BUTTON',
    TRY_AGAIN_BUTTON: 'TRY_AGAIN_BUTTON',
    DONE_BUTTON: 'DONE_BUTTON',
    SCREEN_ALERT_TOKEN_EXPIRED_TITLE: 'SCREEN_ALERT_TOKEN_EXPIRED_TITLE',
    SCREEN_ALERT_TOKEN_EXPIRED_SUBTITLE: 'SCREEN_ALERT_TOKEN_EXPIRED_SUBTITLE',
    SCREEN_FORGOT_PASSWORD: {
        SCREEN_FORGOT_PASSWORD_TITLE: 'SCREEN_FORGOT_PASSWORD_TITLE',
        SCREEN_FORGOT_PASSWORD_BODY_1: 'SCREEN_FORGOT_PASSWORD_BODY_1',
        SCREEN_FORGOT_PASSWORD_WEBSITE_BUTTON:
            'SCREEN_FORGOT_PASSWORD_WEBSITE_BUTTON',
    },
    SCREEN_PLAYER_IN_HOME_DETECTION_MESSAGE:
        'SCREEN_PLAYER_IN_HOME_DETECTION_MESSAGE',
    ALERT_TIMESHIFT_NOT_YET_AVAILABLE_TITLE:
        'ALERT_TIMESHIFT_NOT_YET_AVAILABLE_TITLE',
    ALERT_TIMESHIFT_NOT_YET_AVAILABLE_DESCRIPTION:
        'ALERT_TIMESHIFT_NOT_YET_AVAILABLE_DESCRIPTION',
    CARDS_TITLE_CONTENT_LOCKED: 'CARDS_TITLE_CONTENT_LOCKED',
    ERR_PLAYER_PIN_REQUIRED: 'ERR_PLAYER_PIN_REQUIRED',
    PLAYER_LOCKED_CONTENT_OVERLAY_TITLE: 'PLAYER_LOCKED_CONTENT_OVERLAY_TITLE',
    PLAYER_LOCKED_CONTENT_OVERLAY_DESCRIPTION_RN:
        'PLAYER_LOCKED_CONTENT_OVERLAY_DESCRIPTION_RN',
    PLAYER_BLACKOUT_ERROR_CODE: 'PLAYER_BLACKOUT_ERROR_CODE',
    PLAYER_BLACKOUT_ERROR: 'PLAYER_BLACKOUT_ERROR',
    ERR_A013_INVALID_DEEPLINK_TITLE: 'ERR_A013_INVALID_DEEPLINK_TITLE',
    ERR_A013_INVALID_DEEPLINK_DESCRIPTION:
        'ERR_A013_INVALID_DEEPLINK_DESCRIPTION',
    WELCOME_SCREEN_HEADER: 'WELCOME_SCREEN_HEADER',
    WELCOME_SCREEN_SUBHEADER: 'WELCOME_SCREEN_SUBHEADER',
    WELCOME_SCREEN_LOGIN_BUTTON: 'WELCOME_SCREEN_LOGIN_BUTTON',
    SCREEN_GALLERY_MORE_INFO_BUTTON: 'SCREEN_GALLERY_MORE_INFO_BUTTON',
    LANDING_PAGE_MOBILE_BROWSER_TITLE: 'LANDING_PAGE_MOBILE_BROWSER_TITLE',
    LANDING_PAGE_MOBILE_BROWSER_BODY: 'LANDING_PAGE_MOBILE_BROWSER_BODY',
    LANDING_PAGE_MOBILE_BROWSER_STORE_LABEL:
        'LANDING_PAGE_MOBILE_BROWSER_STORE_LABEL',
    LANDING_PAGE_MOBILE_BROWSER_OR_LABEL:
        'LANDING_PAGE_MOBILE_BROWSER_OR_LABEL',
    LANDING_PAGE_MOBILE_BROWSER_OPEN_APP_BUTTON:
        'LANDING_PAGE_MOBILE_BROWSER_OPEN_APP_BUTTON',
    ADULT_LOCKED_CONTENT_DESCRIPTION: 'ADULT_LOCKED_CONTENT_DESCRIPTION',

    PROFILE: {
        PROFILE_PROFILE_SELECTION_TITLE: 'PROFILE_PROFILE_SELECTION_TITLE',
        PROFILE_PROFILE_SELECTION_DESCRIPTION:
            'PROFILE_PROFILE_SELECTION_DESCRIPTION',
        PROFILE_PROFILE_SELECTION_ADD_PROFILE:
            'PROFILE_PROFILE_SELECTION_ADD_PROFILE',
        PROFILES_TYPE_STANDARD: 'PROFILES_TYPE_STANDARD',
        PROFILES_TYPE_KIDS: 'PROFILES_TYPE_KIDS',
        CONTINUE_BUTTON: 'CONTINUE_BUTTON',
        MANAGE_BUTTON: 'MANAGE_BUTTON',
        PROFILES_ADD_NEW_PROFILE_TITLE: 'PROFILES_ADD_NEW_PROFILE_TITLE',
        PROFILES_ADD_NEW_PROFILE_DESCRIPTION:
            'PROFILES_ADD_NEW_PROFILE_DESCRIPTION',
        PROFILES_ADD_NEW_PROFILE_TYPE_DESCRIPTION:
            'PROFILES_ADD_NEW_PROFILE_TYPE_DESCRIPTION',
        PROFILE_NAME_HINT_TEXT: 'PROFILE_NAME_HINT_TEXT',
        PROFILE_NAME_EMPTY_ERROR: 'PROFILE_NAME_EMPTY_ERROR',
        PROFILE_AGE_RATING_BUTTON: 'PROFILE_AGE_RATING_BUTTON',
        PROFILE_KIDS_AGE_BUTTON: 'PROFILE_KIDS_AGE_BUTTON',
        'PROFILE_AGE_RATING_6+': 'PROFILE_AGE_RATING_6+',
        'PROFILE_AGE_RATING_12+': 'PROFILE_AGE_RATING_12+',
        'PROFILE_AGE_RATING_16+': 'PROFILE_AGE_RATING_16+',
        'PROFILE_AGE_RATING_18+': 'PROFILE_AGE_RATING_18+',
        PROFILE_AGE_RATING_CENSORED: 'PROFILE_AGE_RATING_CENSORED',
        PROFILE_AGE_RATING_UNCENSORED: 'PROFILE_AGE_RATING_UNCENSORED',
        PROFILE_KIDS_AGE_DESCRIPTION: 'PROFILE_KIDS_AGE_DESCRIPTION',
        BUTTON_SAVE: 'BUTTON_SAVE',
        PROFILE_NAME_EXISTING_PROFILE_ERROR:
            'PROFILE_NAME_EXISTING_PROFILE_ERROR',
        PROFILE_ADD_CHANE_ERROR_TITLE: 'PROFILE_ADD_CHANE_ERROR_TITLE',
        PROFILE_ADD_CHANE_ERROR_DESCRIPTION:
            'PROFILE_ADD_CHANE_ERROR_DESCRIPTION',
        PROFILE_AGE_RATING_OVERLAY_1: 'PROFILE_AGE_RATING_OVERLAY_1',
        PROFILE_AGE_RATING_OVERLAY_2: 'PROFILE_AGE_RATING_OVERLAY_2',
        PROFILE_AGE_RATING_OVERLAY_3: 'PROFILE_AGE_RATING_OVERLAY_3',
        PROFILE_AGE_RATING_OVERLAY_4: 'PROFILE_AGE_RATING_OVERLAY_4',
        PROFILE_AGE_RATING_OVERLAY_5: 'PROFILE_AGE_RATING_OVERLAY_5',
        PROFILE_AGE_RATING_OVERLAY_6: 'PROFILE_AGE_RATING_OVERLAY_6',
        PROFILE_AGE_RATING_OVERLAY_7: 'PROFILE_AGE_RATING_OVERLAY_7',
        PROFILE_AGE_RATING_OVERLAY_8: 'PROFILE_AGE_RATING_OVERLAY_8',
        PROFILE_AGE_RATING_OVERLAY_9: 'PROFILE_AGE_RATING_OVERLAY_9',
        PROFILE_AGE_RATING_OVERLAY_10: 'PROFILE_AGE_RATING_OVERLAY_10',
        PROFILE_AGE_RATING_OVERLAY_11: 'PROFILE_AGE_RATING_OVERLAY_11',
        PROFILE_AGE_RATING_OVERLAY_12: 'PROFILE_AGE_RATING_OVERLAY_12',
        PROFILE_AGE_RATING_DROPDOWN_0_5: 'PROFILE_AGE_RATING_DROPDOWN_0_5',
        PROFILE_AGE_RATING_DROPDOWN_6_11: 'PROFILE_AGE_RATING_DROPDOWN_6_11',
        PROFILE_AGE_RATING_DROPDOWN_12_MORE:
            'PROFILE_AGE_RATING_DROPDOWN_12_MORE',
        PROFILE_AGE_RATING_OVERLAY_TITLE: 'PROFILE_AGE_RATING_OVERLAY_TITLE',
        PROFILES_EDIT_PROFILE_TITLE: 'PROFILES_EDIT_PROFILE_TITLE',
        PROFILES_EDIT_PROFILE_DESCRIPTION: 'PROFILES_EDIT_PROFILE_DESCRIPTION',
        DELETE_BUTTON: 'DELETE_BUTTON',
        PROFILE_DELETE_PROFILE_TITLE: 'PROFILE_DELETE_PROFILE_TITLE',
        PROFILE_DELETE_PROFILE_DESCRIPTION:
            'PROFILE_DELETE_PROFILE_DESCRIPTION',
        KEEP_BUTTON: 'KEEP_BUTTON',
        PROFILE_ERROR_TITLE_KIDS_NOT_ALLOWED_TITLE:
            'PROFILE_ERROR_TITLE_KIDS_NOT_ALLOWED_TITLE',
        PROFILE_ERROR_TITLE_KIDS_NOT_ALLOWED_BODY:
            'PROFILE_ERROR_TITLE_KIDS_NOT_ALLOWED_BODY',
        PROFILE_AVATAR_COLLECTION_TITLE: 'PROFILE_AVATAR_COLLECTION_TITLE',
        PROFILE_ERROR_ALERT_DELETE_NOT_ALLOWED_TITLE:
            'PROFILE_ERROR_ALERT_DELETE_NOT_ALLOWED_TITLE',
        PROFILE_ERROR_ALERT_DELETE_NOT_ALLOWED_BODY:
            'PROFILE_ERROR_ALERT_DELETE_NOT_ALLOWED_BODY',
        PROFILE_ERROR_PROFILE_ALREADY_DELETED_TITLE:
            'PROFILE_ERROR_PROFILE_ALREADY_DELETED_TITLE',
        PROFILE_ERROR_PROFILE_ALREADY_DELETED_DESCRIPTION:
            'PROFILE_ERROR_PROFILE_ALREADY_DELETED_DESCRIPTION',
    },
    RECORDING_NOTIFICATION_ONGOING_STARTED:
        'RECORDING_NOTIFICATION_ONGOING_STARTED',
    RECORDING_NOTIFICATION_SCHEDULED_STOPPED:
        'RECORDING_NOTIFICATION_SCHEDULED_STOPPED',
    RECORDING_NOTIFICATION_NEGATIVE_ACTION:
        'RECORDING_NOTIFICATION_NEGATIVE_ACTION',
    SCREEN_ALERT_QUOTA_EXCEEDED_TITLE: 'SCREEN_ALERT_QUOTA_EXCEEDED_TITLE',
    SCREEN_ALERT_QUOTA_EXCEEDED_BODY: 'SCREEN_ALERT_QUOTA_EXCEEDED_BODY',
    SCREEN_AUDIO_SUBTITLES_TITLE_GOT_IT_BUTTON:
        'SCREEN_AUDIO_SUBTITLES_TITLE_GOT_IT_BUTTON',
    CLOSE_BUTTON: 'CLOSE_BUTTON',
    ERROR_SERVICE_NOT_AVAILABLE_TITLE: 'ERROR_SERVICE_NOT_AVAILABLE_TITLE',
    ERROR_SERVICE_NOT_AVAILABLE_BODY: 'ERROR_SERVICE_NOT_AVAILABLE_BODY',
    RELOAD_BUTTON: 'RELOAD_BUTTON',
    REBOOT_BUTTON: 'REBOOT_BUTTON',
    SELFCARE_APP_BUTTON: 'SELFCARE_APP_BUTTON',
    SUBSCRIBE_OVERLAY_SELFCARE_LINK: 'SUBSCRIBE_OVERLAY_SELFCARE_LINK',
    PLAYER_SOURCE_TYPE_ERROR: 'PLAYER_SOURCE_TYPE_ERROR',
    PLAYER_MEDIA_TYPE_ERROR: 'PLAYER_MEDIA_TYPE_ERROR',
    PLAYER_NETWORK_TYPE_ERROR: 'PLAYER_NETWORK_TYPE_ERROR',
    PLAYER_DRM_TYPE_ERROR: 'PLAYER_DRM_TYPE_ERROR',
    PLAYER_SSM_TYPE_ERROR: 'PLAYER_SSM_TYPE_ERROR',
    PLAYER_TYPE_ERROR: 'PLAYER_TYPE_ERROR',
    ERR_GENERIC_TITLE: 'ERR_GENERIC_TITLE',
    PLAYER_ERROR_CONCURRENCY_ERROR: 'PLAYER_ERROR_CONCURRENCY_ERROR',
    HIDE_UNSUBSCRIBED_CHANNELS_TOGGLE: 'HIDE_UNSUBSCRIBED_CHANNELS_TOGGLE',

    ACCESSIBILITY: {
        LOGIN: {
            ACCESSIBILITY_LOGIN_USERNAME_INPUT:
                'ACCESSIBILITY_LOGIN_USERNAME_INPUT',
            ACCESSIBILITY_LOGIN_PASSWORD_INPUT:
                'ACCESSIBILITY_LOGIN_PASSWORD_INPUT',
            ACCESSIBILITY_LOGIN_SHOW_HIDE_PASSWORD:
                'ACCESSIBILITY_LOGIN_SHOW_HIDE_PASSWORD',
            ACCESSIBILITY_LOGIN_FORGOT_PASSWORD:
                'ACCESSIBILITY_LOGIN_FORGOT_PASSWORD',
            ACCESSIBILITY_LOGIN_PRIVACY_POLICY_TERMS:
                'ACCESSIBILITY_LOGIN_PRIVACY_POLICY_TERMS',
            ACCESSIBILITY_LOGIN_LOGIN_BUTTON:
                'ACCESSIBILITY_LOGIN_LOGIN_BUTTON',
            ACCESSIBILITY_LOGIN_LOGIN_BUTTON_WEB:
                'ACCESSIBILITY_LOGIN_LOGIN_BUTTON_WEB',
            ACCESSIBILITY_CLOSE_BUTTON: 'ACCESSIBILITY_CLOSE_BUTTON',
            ACCESSIBILITY_LOGIN_SELFCARE_BUTTON:
                'ACCESSIBILITY_LOGIN_SELFCARE_BUTTON',
        },
        EPG: {
            ACCESSIBILITY_EPG_NOW_INDICATOR: 'ACCESSIBILITY_EPG_NOW_INDICATOR',
            ACCESSIBILITY_EPG_START_END_TIME:
                'ACCESSIBILITY_EPG_START_END_TIME',
            ACCESSIBILITY_EPG_FILTER_ICON: 'ACCESSIBILITY_EPG_FILTER_ICON',
            ACCESSIBILITY_EPG_DAY_SELECTOR: 'ACCESSIBILITY_EPG_DAY_SELECTOR',
        },
        NAVIGATION: {
            ACCESSIBILITY_ICON_HOME: 'ACCESSIBILITY_ICON_HOME',
            ACCESSIBILITY_ICON_EPG: 'ACCESSIBILITY_ICON_EPG',
            ACCESSIBILITY_ICON_RECORDINGS: 'ACCESSIBILITY_ICON_RECORDINGS',
            ACCESSIBILITY_ICON_ONDEMAND: 'ACCESSIBILITY_ICON_ONDEMAND',
            ACCESSIBILITY_ICON_SEARCH: 'ACCESSIBILITY_ICON_SEARCH',
            ACCESSIBILITY_ICON_SETTINGS: 'ACCESSIBILITY_ICON_SETTINGS',
            ACCESSIBILITY_ICON_PROFILE: 'ACCESSIBILITY_ICON_PROFILE',
        },
        DETAIL_PAGE: {
            ACCESSIBILITY_DETAIL_PAGE_MORE_OPTION:
                'ACCESSIBILITY_DETAIL_PAGE_MORE_OPTION',
            ACCESSIBILITY_ICON_GENERAL_AUDIENCE:
                'ACCESSIBILITY_ICON_GENERAL_AUDIENCE',
            ACCESSIBILITY_ICON_6: 'ACCESSIBILITY_ICON_6',
            ACCESSIBILITY_ICON_12: 'ACCESSIBILITY_ICON_12',
            ACCESSIBILITY_ICON_16: 'ACCESSIBILITY_ICON_16',
            ACCESSIBILITY_ICON_18: 'ACCESSIBILITY_ICON_18',
            ACCESSIBILITY_ICON_LOCKED: 'ACCESSIBILITY_ICON_LOCKED',
            ACCESSIBILITY_ICON_SHOPPING_CART:
                'ACCESSIBILITY_ICON_SHOPPING_CART',
            ACCESSIBILITY_ICON_CATCHUP: 'ACCESSIBILITY_ICON_CATCHUP',
            ACCESSIBILITY_ICONS_SINGLE_RECORDING:
                'ACCESSIBILITY_ICONS_SINGLE_RECORDING',
            ACCESSIBILITY_ICONS_SCHEDULED_SINGLE_RECORDING:
                'ACCESSIBILITY_ICONS_SCHEDULED_SINGLE_RECORDING',
            ACCESSIBILITY_ICONS_SERIES_RECORDING:
                'ACCESSIBILITY_ICONS_SERIES_RECORDING',
            ACCESSIBILITY_ICONS_SCHEDULED_SERIES_RECORDING:
                'ACCESSIBILITY_ICONS_SCHEDULED_SERIES_RECORDING',
            ACCESSIBILITY_ICONS_PROTECTED_RECORDING:
                'ACCESSIBILITY_ICONS_PROTECTED_RECORDING',
            ACCESSIBILITY_ICONS_FAILED_RECORDING:
                'ACCESSIBILITY_ICONS_FAILED_RECORDING',
            ACCSESSIBILITY_DETAIL_PAGE_BACK: 'ACCSESSIBILITY_DETAIL_PAGE_BACK',
            ACCESSIBILITY_DETAIL_PAGE_PROGRAMS_TAB:
                'ACCESSIBILITY_DETAIL_PAGE_PROGRAMS_TAB',
            ACCESSIBILITY_DETAIL_PAGE_RECORDINGS_TAB:
                'ACCESSIBILITY_DETAIL_PAGE_RECORDINGS_TAB',
        },
        PLAYER: {
            ACCESSIBILITY_PLAYER_PROGRESS_BAR:
                'ACCESSIBILITY_PLAYER_PROGRESS_BAR',
            ACCESSIBILITY_PLAYER_MAXIMIZE: 'ACCESSIBILITY_PLAYER_MAXIMIZE',
            ACCESSIBILITY_PLAYER_MINIMIZE: 'ACCESSIBILITY_PLAYER_MINIMIZE',
            ACCESSIBILITY_PLAYER_AUDIO_AND_SUBTITLE:
                'ACCESSIBILITY_PLAYER_AUDIO_AND_SUBTITLE',
            ACCESSIBILITY_PLAYER_CLOSE: 'ACCESSIBILITY_PLAYER_CLOSE',
            ACCESSIBILITY_PLAYER_OPEN_DETAIL_PAGE:
                'ACCESSIBILITY_PLAYER_OPEN_DETAIL_PAGE',
            ACCESSIBILITY_PLAYER_OPEN_DETAIL_PAGE_WEB:
                'ACCESSIBILITY_PLAYER_OPEN_DETAIL_PAGE_WEB',
            ACCESSIBILITY_PLAYER_PLAY: 'ACCESSIBILITY_PLAYER_PLAY',
            ACCESSIBILITY_PLAYER_PAUSE: 'ACCESSIBILITY_PLAYER_PAUSE',
            ACCESSIBILITY_PLAYER_SKIPP_BACKWARDS:
                'ACCESSIBILITY_PLAYER_SKIPP_BACKWARDS',
            ACCESSIBILITY_PLAYER_SKIPP_FORWARD:
                'ACCESSIBILITY_PLAYER_SKIPP_FORWARD',
            ACCESSIBILITY_PLAYER_FRAME_FITTING_BUTTON:
                'ACCESSIBILITY_PLAYER_FRAME_FITTING_BUTTON',
            ACCESSIBILITY_PLAYER_AIR_PLAY_BUTTON:
                'ACCESSIBILITY_PLAYER_AIR_PLAY_BUTTON',
            ACCESSIBILITY_PLAYER_RECORD: 'ACCESSIBILITY_PLAYER_RECORD',
            ACCESSIBILITY_PLAYER_STARTOVER: 'ACCESSIBILITY_PLAYER_STARTOVER',
            ACCESSIBILITY_PLAYER_JUMP_TO_LIVE:
                'ACCESSIBILITY_PLAYER_JUMP_TO_LIVE',
            ACCESSIBILITY_PLAYER_OVERLAY_CONTROLS:
                'ACCESSIBILITY_PLAYER_OVERLAY_CONTROLS',
            ACCESSIBILITY_PLAYER_CLOSE_RECORDINGS_OVERLAY:
                'ACCESSIBILITY_PLAYER_CLOSE_RECORDINGS_OVERLAY',
            ACCESSIBILITY_PLAYER_CLOSE_AUDIO_AND_SUBTITLE_OVERLAY:
                'ACCESSIBILITY_PLAYER_CLOSE_AUDIO_AND_SUBTITLE_OVERLAY',
            ACCESSIBILITY_PLAYER_BRIGHTNESS_CONTROL:
                'ACCESSIBILITY_PLAYER_BRIGHTNESS_CONTROL',
            ACCESSIBILITY_PLAYER_BRIGHTNESS_CONTROL_INCREMENT_ACTION:
                'ACCESSIBILITY_PLAYER_BRIGHTNESS_CONTROL_INCREMENT_ACTION',
            ACCESSIBILITY_PLAYER_BRIGHTNESS_CONTROL_DECREMENT_ACTION:
                'ACCESSIBILITY_PLAYER_BRIGHTNESS_CONTROL_DECREMENT_ACTION',
            ACCESSIBILITY_PLAYER_WIFI_ICON: 'ACCESSIBILITY_PLAYER_WIFI_ICON',
            ACCESSIBILITY_PLAYER_MOBILE_DATA_ICON:
                'ACCESSIBILITY_PLAYER_MOBILE_DATA_ICON',
            ACCESSIBILITY_PLAYER_MUTE: 'ACCESSIBILITY_PLAYER_MUTE',
            ACCESSIBILITY_PLAYER_UNMUTE: 'ACCESSIBILITY_PLAYER_UNMUTE',
            ACCESSIBILITY_PLAYER_VOLUME_BAR: 'ACCESSIBILITY_PLAYER_VOLUME_BAR',
            ACCESSIBILITY_BINGE_WATCHING_RN: 'ACCESSIBILITY_BINGE_WATCHING_RN',
        },
        SETTINGS: {
            MY_STREAMIN_SUBSCRIPTIONS: {
                ACCESSIBILITY_NETFLIX_LOGO: 'ACCESSIBILITY_NETFLIX_LOGO',
                ACCESSIBILITY_DA_VINCI_LOGO: 'ACCESSIBILITY_DA_VINCI_LOGO',
                ACCESSIBILITY_FOUR_NET_LOGO: 'ACCESSIBILITY_FOUR_NET_LOGO',
                ACCESSIBILITY_PRIME_VIDEO_LOGO:
                    'ACCESSIBILITY_PRIME_VIDEO_LOGO',
                ACCESSIBILITY_HBO_MAX_LOGO: 'ACCESSIBILITY_HBO_MAX_LOGO',
                ACCESSIBILITY_RTL_PLUS_LOGO: 'ACCESSIBILITY_RTL_PLUS_LOGO',
                ACCESSIBILITY_TV_TWO_LOGO: 'ACCESSIBILITY_TV_TWO_LOGO',
                ACCESSIBILITY_FILM_BOX_PLUS_LOGO:
                    'ACCESSIBILITY_FILM_BOX_PLUS_LOGO',
                ACCESSIBILITY_SELF_CARE_APP_BUTTON_SUBSCRIPTIONS:
                    'ACCESSIBILITY_SELF_CARE_APP_BUTTON_SUBSCRIPTIONS',
            },
            RECORDING_QUOTA: {
                ACCESSIBILITY_SETTINGS_REC_QUOTA_HOUR:
                    'ACCESSIBILITY_SETTINGS_REC_QUOTA_HOUR',
                ACCESSIBILITY_SETTINGS_REC_QUOTA_HOURS:
                    'ACCESSIBILITY_SETTINGS_REC_QUOTA_HOURS',
            },
            CHANNEL_LINEUP: {
                ACCESSIBILITY_MY_LIST_TOGGLE_ON:
                    'ACCESSIBILITY_MY_LIST_TOGGLE_ON',
                ACCESSIBILITY_MY_LIST_TOGGLE_OFF:
                    'ACCESSIBILITY_MY_LIST_TOGGLE_OFF',
                ACCESSIBILITY_MY_LIST_HIDE_CHANNEL:
                    'ACCESSIBILITY_MY_LIST_HIDE_CHANNEL',
                ACCESSIBILITY_MY_LIST_SHOW_CHANNEL:
                    'ACCESSIBILITY_MY_LIST_SHOW_CHANNEL',
            },
            ACCESSIBILITY_SETTINGS_CHECKMARK:
                'ACCESSIBILITY_SETTINGS_CHECKMARK',
            ACCESSIBILITY_SETTINGS_ITEM_LIST:
                'ACCESSIBILITY_SETTINGS_ITEM_LIST',
        },
        GALLERY: {
            ACCESSIBILITY_GALLERY_SWITCH_TO_NEXT_ASSET:
                'ACCESSIBILITY_GALLERY_SWITCH_TO_NEXT_ASSET',
            ACCESSIBILITY_GALLERY_SWITCH_TO_PREVIOUS_ASSET:
                'ACCESSIBILITY_GALLERY_SWITCH_TO_PREVIOUS_ASSET',
            ACCESSIBILITY_GALLERY_FIRST_ASSET:
                'ACCESSIBILITY_GALLERY_FIRST_ASSET',
        },
        STRIPE: {
            ACCESSIBILITY_STRIPE_FIRST_ASSET:
                'ACCESSIBILITY_STRIPE_FIRST_ASSET',
        },
        ARROWS: {
            ACCESSIBILITY_WEB_UP_ARROW: 'ACCESSIBILITY_WEB_UP_ARROW',
            ACCESSIBILITY_WEB_DOWN_ARROW: 'ACCESSIBILITY_WEB_DOWN_ARROW',
            ACCESSIBILITY_WEB_LEFT_ARROW: 'ACCESSIBILITY_WEB_LEFT_ARROW',
            ACCESSIBILITY_WEB_RIGHT_ARROW: 'ACCESSIBILITY_WEB_RIGHT_ARROW',
        },

        ACCESSIBILITY_GENERAL_TAPP_TWICE: 'ACCESSIBILITY_GENERAL_TAPP_TWICE',
        ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB:
            'ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB',
        ACCESSIBILITY_COLLECTION_FIRST_ASSET:
            'ACCESSIBILITY_COLLECTION_FIRST_ASSET',
        ACCESSIBILITY_WEB_GALLERY_SLIDE: 'ACCESSIBILITY_WEB_GALLERY_SLIDE',
        LANDING: {
            ACCESSIBILITY_LANDING_PAGE_GOOGLE_PLAY_BUTTON:
                'ACCESSIBILITY_LANDING_PAGE_GOOGLE_PLAY_BUTTON',
            ACCESSIBILITY_LANDING_PAGE_APP_STORE_BUTTON:
                'ACCESSIBILITY_LANDING_PAGE_APP_STORE_BUTTON',
        },
        SEARCH: {
            ACCESSIBILITY_SEARCH_HINT_RN: 'ACCESSIBILITY_SEARCH_HINT_RN',
            ACCESSIBILITY_SEARCH_X_CLEAR_ICON:
                'ACCESSIBILITY_SEARCH_X_CLEAR_ICON',
            ACCESSIBILITY_SEARCH_RESULTS_FOUND:
                'ACCESSIBILITY_SEARCH_RESULTS_FOUND',
            ACCESSIBILITY_SEARCH_NO_RESULTS: 'ACCESSIBILITY_SEARCH_NO_RESULTS',
        },
        PROFILE: {
            ACCESSIBILITY_PROFILE_IN_USE: 'ACCESSIBILITY_PROFILE_IN_USE',
            ACCESSIBILITY_PROFILE_EDIT: 'ACCESSIBILITY_PROFILE_EDIT',
            ACCESSIBILITY_PROFILE_EDIT_IMAGE:
                'ACCESSIBILITY_PROFILE_EDIT_IMAGE',
            ACCESSIBILITY_PROFILE_EDIT_PROFILE_NAME:
                'ACCESSIBILITY_PROFILE_EDIT_PROFILE_NAME',
        },
    },
    SKIP_BUTTON: 'SKIP_BUTTON',
    SETTINGS_FORGOT_PIN_OK: 'SETTINGS_FORGOT_PIN_OK',
    PLAYER_ACTION_NOT_ALLOWED_TITLE: 'PLAYER_ACTION_NOT_ALLOWED_TITLE',
    PLAYER_ACTION_NOT_ALLOWED_BODY: 'PLAYER_ACTION_NOT_ALLOWED_BODY',
    AIRPLAY_PLAYER_CONNECTED_TO_RECEIVER:
        'AIRPLAY_PLAYER_CONNECTED_TO_RECEIVER',
    FORCE_UPDATE: {
        LATEST_STORE_VERSION_ANDROID: 'LATEST_STORE_VERSION_ANDROID',
        LATEST_STORE_VERSION_IOS: 'LATEST_STORE_VERSION_IOS',
        MANDATORY_UPDATE_DATE_IOS: 'MANDATORY_UPDATE_DATE_IOS',
        MANDATORY_UPDATE_DATE_ANDROID: 'MANDATORY_UPDATE_DATE_ANDROID',
        NOTIFICATION_UPDATE_APP_VERSION_TITLE_1:
            'NOTIFICATION_UPDATE_APP_VERSION_TITLE_1',
        NOTIFICATION_UPDATE_APP_VERSION_DESCRIPTION_1:
            'NOTIFICATION_UPDATE_APP_VERSION_DESCRIPTION_1',
        BUTTON_IGNORE: 'BUTTON_IGNORE',
        BUTTON_GO_TO_APP_STORE: 'BUTTON_GO_TO_APP_STORE',
        NOTIFICATION_UPDATE_APP_VERSION_TITLE_3:
            'NOTIFICATION_UPDATE_APP_VERSION_TITLE_3',
        NOTIFICATION_UPDATE_APP_VERSION_DESCRIPTION_3:
            'NOTIFICATION_UPDATE_APP_VERSION_DESCRIPTION_3',
    },
    BINGE_WATCHING: {
        BINGE_WATCHING_NEXT_LABEL: 'BINGE_WATCHING_NEXT_LABEL',
        BINGE_WATCHING_NEXT_STARTS_IN: 'BINGE_WATCHING_NEXT_STARTS_IN',
    },
    VITAL_REQUEST_FAILED_RETRY_TITLE: 'VITAL_REQUEST_FAILED_RETRY_TITLE',
    VITAL_REQUEST_FAILED_RETRY_DESCRIPTION:
        'VITAL_REQUEST_FAILED_RETRY_DESCRIPTION',
    ERROR_EMPTY_TEMPLATE_RESPONSE: 'ERROR_EMPTY_TEMPLATE_RESPONSE',
    EMPTY_CONTENT_PAGES_GLOBAL: 'EMPTY_CONTENT_PAGES_GLOBAL',
    EMPTY_CONTENT_PAGES_NO_RECORDING_CAPABILITY:
        'EMPTY_CONTENT_PAGES_NO_RECORDING_CAPABILITY',
    EMPTY_CONTENT_PAGES_RECORDING_BE_ERROR:
        'EMPTY_CONTENT_PAGES_RECORDING_BE_ERROR',
    ALERT_RECORDING_NOT_AVAILABLE_DESCRIPTION:
        'ALERT_RECORDING_NOT_AVAILABLE_DESCRIPTION',
};
